<template>
  <div>
    <router-view />
    <!-- Global confirm modal instance bound to composable state -->
    <ConfirmModal
      v-model="showConfirm"
      :title="confirmTitle"
      :message="confirmMessage"
      :confirm-text="confirmConfirmText"
      :cancel-text="confirmCancelText"
      @confirm="() => handleConfirm(true)"
      @cancel="() => handleConfirm(false)"
    />
  </div>
</template>
<script setup>
import { useConfirm } from './stores/composables.js'
const { showConfirm, confirmMessage, confirmTitle, confirmConfirmText, confirmCancelText, onConfirm } = useConfirm()

function handleConfirm(val) {
  onConfirm(val)
}
</script>
<style></style>
